import { render, staticRenderFns } from "./ConfirmationPopup.vue?vue&type=template&id=3612acfc&scoped=true&"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612acfc",
  null
  
)

export default component.exports